import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import { trackEvent } from "@/lib/tracking";

// Row of tall service cards that flip on hover to reveal a description,
// then navigate to the service's expanded page on click.
export default function ServiceCards({ services = SERVICES, categoryCards = false }) {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 ${categoryCards ? "lg:grid-cols-4" : "lg:grid-cols-5"} gap-4`}>
      {services.map((s) => {
        const to = s.cta || `/services/${s.slug}`;
        return (
          <Link
            key={s.slug}
            to={to}
            data-testid={`service-card-${s.key}`}
            onClick={() => trackEvent("service_view", { label: s.title })}
            className="group block [perspective:1400px]"
          >
            <div className="relative h-[320px] sm:h-[440px] w-full transition-transform duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
              {/* FRONT — image + title */}
              <div className="absolute inset-0 rounded-2xl overflow-hidden [backface-visibility:hidden]">
                <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-rc-charcoal via-rc-charcoal/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-heading font-bold text-white text-xl leading-tight">{s.title}</h3>
                  <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.2em] text-rc-sand">Hover to explore</div>
                </div>
              </div>

              {/* BACK — description + CTA */}
              <div className="absolute inset-0 rounded-2xl overflow-hidden bg-rc-red flex flex-col p-5 [backface-visibility:hidden] [transform:rotateY(180deg)]">
                <h3 className="font-heading font-bold text-white text-lg leading-tight">{s.title}</h3>
                <p className="mt-3 text-white/90 text-sm leading-snug flex-1">{s.desc}</p>
                <div className="inline-flex items-center gap-1.5 text-white font-bold text-xs uppercase tracking-[0.14em] pt-3 border-t border-white/25">
                  View Service <ArrowUpRight size={15} />
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
